/**
 * 官网弹窗统一是左侧划出的抽屉（<dialog class="official-dialog"> + showModal，样式在 official-promotion.scss）。
 * 这里只管关闭：先播划出动画再真正 close；点遮罩也算关闭。
 */
const CLOSE_MS = 200

export function closeDrawer(dialog: HTMLDialogElement | null | undefined): void {
  if (!dialog?.open || dialog.classList.contains('official-dialog-closing')) return
  if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) {
    dialog.close()
    return
  }
  dialog.classList.add('official-dialog-closing')
  window.setTimeout(() => {
    dialog.classList.remove('official-dialog-closing')
    dialog.close()
  }, CLOSE_MS)
}

/**
 * 遮罩属于 <dialog> 自身，点遮罩和点抽屉内边距的 event.target 都是 dialog，
 * 所以按坐标判断是否落在抽屉矩形之外。
 */
export function closeDrawerOnBackdrop(event: MouseEvent): void {
  const dialog = event.currentTarget as HTMLDialogElement
  if (event.target !== dialog) return
  const rect = dialog.getBoundingClientRect()
  const inside = event.clientX >= rect.left && event.clientX <= rect.right
    && event.clientY >= rect.top && event.clientY <= rect.bottom
  if (!inside) closeDrawer(dialog)
}
